import { createFileRoute, redirect } from "@tanstack/react-router";
import { Box, Button, Typography } from "@flukecorp-emu/common-ui";
import { initiateLogin } from "../services/auth";

export const Route = createFileRoute("/login")({
  beforeLoad: async ({ context }) => {
    if (context?.auth?.isAuthenticated) {
      return redirect({
        to: import.meta.env.VITE_APP_BASE_PATH || "/",
      });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect: redirectPath } = Route.useSearch();

  const handleSignIn = () => {
    initiateLogin(redirectPath);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        px: 3,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 460,
          p: 4,
          borderRadius: 2,
          backgroundColor: "#FFFFFF",
          boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" sx={{ mb: 1 }}>
          Sign in to Fluke Admin Portal
        </Typography>
        <Typography color="textSecondary" sx={{ mb: 3 }}>
          Continue with your organization account to access the admin portal.
        </Typography>
        <Button variant="contained" size="large" onClick={handleSignIn} fullWidth>
          Sign in
        </Button>
      </Box>
    </Box>
  );
}
